import React from "react";
import { Modal, Box } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const GearModal = ({ open, handleClose }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <iframe
          src="https://dev2.4pay.ca:3000/adminportal2020/ref_screens/loancategorieslist.php"
          title="Loan Categories"
          width="100%"
          height="400px"
        ></iframe>
      </Box>
    </Modal>
  );
};

export default GearModal;
